import { PhoneNumberUtil, PhoneNumberFormat } from 'google-libphonenumber';

const phoneUtil = PhoneNumberUtil.getInstance();

export const formatPhoneNumber = (phoneNumberString: string): string | null => {
  if (!phoneNumberString) return null;

  const cleaned = phoneNumberString.replace(/[^\d+]/g, '');
  if (!cleaned) return null;

  const normalized = cleaned.startsWith('+') ? cleaned : `+${cleaned}`;

  try {
    const parsed = phoneUtil.parse(normalized);
    if (phoneUtil.isValidNumber(parsed)) {
      return phoneUtil.format(parsed, PhoneNumberFormat.INTERNATIONAL);
    }
    if (phoneUtil.isPossibleNumber(parsed)) {
      return normalized;
    }
    return null;
  } catch {
    return null;
  }
};

export const displayPhoneNumber = (phoneNumber?: string | null) => {
  if (!phoneNumber) {
    return '-';
  }
  return formatPhoneNumber(phoneNumber) ?? phoneNumber;
};
